/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {acceptMulticurrencyQuote} from '../api'

export const useMutationAcceptMulticurrencyQuote = createReactQueryMutationHook('acceptMulticurrencyQuote', acceptMulticurrencyQuote)
